import { ReactNode } from "react";

export enum NotificationVariant {
  SUCCESS = 'success',
  WARNING = 'warning',
  DEFAULT = 'default',
}

export type NotificationProps = {
  icon?: string
  title?: string | ReactNode
  subTitle?: string | ReactNode
  variant?: NotificationVariant
  children: ReactNode
  className?: string
}
